"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = exports.Input = exports.Switch = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Switch = styled_components_1.default.label`
  position: relative;
  display: inline-block;
  height: ${props => props.toggleHeight}px;
  width: ${props => props.toggleWidth}px;
`;
exports.Input = styled_components_1.default.input.attrs({
  type: 'checkbox'
})`
  opacity: 0;
  width: 0;
  height: 0;
`;
exports.Slider = styled_components_1.default.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
  border-radius: 200px;
  background-color: ${props => props.toggleBg || props.theme.colors.gray_500};

  &::before {
    content: '';
    position: absolute;
    height: ${props => props.sliderRadius}px;
    width: ${props => props.sliderRadius}px;
    bottom: ${props => props.sliderOffset}px;
    left: ${props => props.sliderOffset}px;
    transition: 0.4s;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.white};
  }

  ${exports.Input}:checked + & {
    background-color: ${props => props.toggleBgActive || props.theme.colors.primary_700_main};
  }

  ${exports.Input}:checked + &:before {
    transform: translateX(${props => props.sliderOnOffset}px);
  }
  ${exports.Input}:focus + & {
    box-shadow: 0 0 1px ${props => props.toggleBgActive || props.theme.colors.primary_700_main};
  }
  ${props => props.isDisabled && (0, styled_components_1.css)`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;